import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import PhotoPermissionsUtil from '../../../../../helpers/permissions/PhotoPermissionsUtil';
import BaseComponent from '../../../../../baseClasses/BaseComponent';
import StepApproval from '../../TaskCompletionSteps/StepApproval';
import TaskCompletionStepComments from '../TaskCompletionStepComments';
import CommentPopup from '../CommentPopup';
import VideoPlayer from '../../../../../components/VideoPlayer';
import dataModel from '../../../../../models/DataModel';
import FileUtil from '../../../../../helpers/FileUtil/FileUtil';
import ModalBannerConstants from '../../../../../constants/ModalBannerConstants';
import MiscConstants from '../../../../../constants/MiscConstants';
import AttachmentHelper from '../../../../../helpers/AttachmentHelper';
import fileTypePdfIcon from '../../../../../assets/images/pdf-default.png';
import fileTypeDocIcon from '../../../../../assets/images/doc-default.png';
import fileTypeXlsIcon from '../../../../../assets/images/xls-default.png';
import fileTypeMovIcon from '../../../../../assets/images/video-default.png';
import fileTypeOtherIcon from '../../../../../assets/images/other-default.png';

import naVideoIcon from '../../../../../assets/images/na-video.svg';
import naOtherIcon from '../../../../../assets/images/na-other.svg';
import naExcelIcon from '../../../../../assets/images/na-excel.svg';
import naPdfIcon from '../../../../../assets/images/na-pdf.svg';
import naDocIcon from '../../../../../assets/images/na-doc.svg';

import AnalyticsLogger from '../../../../../helpers/analytics/analyticsLogger';
import CompletionStepPermissionsUtil from '../../../../../helpers/permissions/CompletionStepPermissionsUtil';
import FileCard from '../../../../TaskCompletionStepsMobile/PhotoUpload/TaskCompletionStepPhotoGrid/FileCard';
import AttachmentPopup from '../../../../AttachmentPopup';
import DataSource from '../../../../../dao/DataSource/DataSource';
import AttachmentUploading from '../../../../AttachmentUploading';

import './MiscUpload.scss';

const fileTypeToNAIcons = {
  'mp4': naVideoIcon,
  'Other': naOtherIcon,
  'xls': naExcelIcon,
  'pdf': naPdfIcon,
  'doc': naDocIcon,
};

const completionCiteriaSelector = {
  completion_criteria: {
    attachments: {
      additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'],
      conversions: {},
      user: {},
    },
    comments: { user: { additionalFields: ['profile_image'] } },
    event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} },
    form_fields: {},
  },
};

export class MiscUpload extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      stepState: '',
      uploadsInProgress: [],
      naButton: false,
      displayedFile: null,
      completionStep: props.completionStep,
    };
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    this.fileTypeInfo = this.getFileTypeInfo();

    this.showUploadModal = this.showUploadModal.bind(this);
    this.displayFile = this.displayFile.bind(this);
    this.canOverrideUpload = this.canOverrideUpload.bind(this);
  }

  handleCSUpdate(completionStep, action, acData, fetchedData) {
    this.setState({ completionStep });
    this.checkForNA();
    if (completionStep.attachments) {
      this.fileTypeInfo = this.getFileTypeInfo(completionStep);
    }
  }

  componentDidMount() {
    const { completionStep } = this.props;

    this.csDataSource = new DataSource('CompletionCriterion', completionStep.id, completionCiteriaSelector, this.handleCSUpdate);
    this.csDataSource.get();
  }

  componentDidUpdate(prevProps) {
    if (this.props.attachmentUploading !== this.state.attachmentUploading) {
      if(this.props.attachmentUploading == false){
        this.checkForNA();
        window.location.reload();
      }
      this.setState({ attachmentUploading: this.props.attachmentUploading });
    }
  }

  componentWillUnmount() {
    if (this.csDataSource) {
      this.csDataSource.release();
      this.csDataSource = null;
    }
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  canOverrideUpload() {
    const { task, userStepPermissions } = this.props;
    const { completionStep } = this.state;
    return CompletionStepPermissionsUtil.canOverrideUpload(task, completionStep, userStepPermissions);
  }

  checkForNA() {
    const { userStepPermissions } = this.props;
    const { completionStep } = this.state;
    if (!(completionStep.attachments && completionStep.attachments.length > 0) &&
      !completionStep.not_applicable && 
      userStepPermissions.has('step_complete') && 
      !completionStep.completed_at
    ) {
      if (!this.state.naButton) this.setState({ naButton: true });
    } 
    else if (this.state.naButton) {
      this.setState({ naButton: false });
    }
  }

  getFileTypeInfo(completionStep) {
    if (!completionStep) {
      completionStep = this.state.completionStep;
    }
    let type = completionStep.requested_file_type;
    let acceptedTypes = { acceptedTypes: null, defaultImage: null, filledImage: null };
    const hasAttachments = completionStep.attachments.length > 0;
    if (type) {
      switch (type.toLowerCase()) {
      case 'pdf':
        acceptedTypes.acceptedTypes = FileUtil.getAcceptedExtensionsByType('pdf', false, true);
        acceptedTypes.defaultImage = fileTypePdfIcon;
          // TODO: remove these checks and call method to get filled image in render
        if (hasAttachments) {
          acceptedTypes.filledImage = <div className='display-container'>
            {AttachmentHelper.getConvertedDocumentView(completionStep.attachments[0])}</div>;
        }
        break;
      case 'xls':
      case 'xlt':
      case 'xlm':
      case 'xlsm':
      case 'xlsx':
      case 'xltx':
        acceptedTypes.acceptedTypes = FileUtil.getAcceptedExtensionsByType('xls', false, true);
        acceptedTypes.defaultImage = fileTypeXlsIcon;
        if (hasAttachments) {
          acceptedTypes.filledImage = <div className='display-container'>
            {AttachmentHelper.getConvertedDocumentView(completionStep.attachments[0])}</div>;
        }
        break;
      case 'doc':
      case 'docx':
      case 'dotx':
      case 'dot':
      case 'dotm':
        acceptedTypes.acceptedTypes = FileUtil.getAcceptedExtensionsByType('doc', false, true);
        acceptedTypes.defaultImage = fileTypeDocIcon;
        if (hasAttachments) {
          acceptedTypes.filledImage = <div className='display-container'>
            {AttachmentHelper.getConvertedDocumentView(completionStep.attachments[0])}</div>;
        }
        break;
      case 'mp4':
      case 'mov':
      case 'avi':
      case 'wmv':
      case 'flv':
        acceptedTypes.acceptedTypes = FileUtil.getAcceptedExtensionsByType('mp4', false, true);
        acceptedTypes.defaultImage = fileTypeMovIcon;
        if (hasAttachments) {
          const attachment = completionStep.attachments[0];
          const type = attachment.upload_content_type ? attachment.upload_content_type : (attachment.upload && attachment.upload.type) ? attachment.upload.type : undefined;
          acceptedTypes.filledImage = <VideoPlayer src={attachment.upload} width={460} height={328} type={type}/>;
        }
        break;
      default:
        acceptedTypes.acceptedTypes = [];
        acceptedTypes.defaultImage = fileTypeOtherIcon;
        if (hasAttachments) {
          acceptedTypes.filledImage = <div className='display-container'>
            {AttachmentHelper.getConvertedDocumentView(completionStep.attachments[0])}</div>;
        }
        break;
      }
    }
    return acceptedTypes;
  }

  showUploadModal() {
    const { completionStep, uploadsInProgress } = this.state;
    const totalUploads = completionStep.attachments.length + uploadsInProgress.length;

    dataModel.showGlobalModal(ModalBannerConstants.FILE_UPLOADER, {
      acceptedFileTypes: this.fileTypeInfo.acceptedTypes,
      handleFileSelect: this.handleSaveFile,
      currentNumberOfFiles: totalUploads,
      maximumAllowedFiles: MiscConstants.MAX_NUMBER_OF_FILES,
    });
  }

  displayFile(attachment) {
    this.setState({ displayedFile: attachment });
  }

  handleCloseAttachmentPopup() {
    this.setState({ displayedFile: null });
  }

  handleSaveFile(file) {
    const { uploadsInProgress } = this.state;
    const clonedStep = _.cloneDeep(this.state.completionStep);
    if ((clonedStep.attachments.length + uploadsInProgress.length) >= MiscConstants.MAX_NUMBER_OF_FILES) {
      return;
    }
    const attachment = {};
    attachment.id = dataModel.attachmentsDAO.creationIndex;
    attachment.attachable_type = 'CompletionCriterion';
    attachment.attachable_id = clonedStep.id;
    attachment.upload = file;
    attachment.name = file.name;

    uploadsInProgress.push(attachment);
    this.setState({ uploadsInProgress, uploadImage: true });

    dataModel.attachmentUploading = true;
    dataModel.attachmentsDAO.createAttachment(attachment, false).then((createdAttachment) => {
      _.remove(uploadsInProgress, upload => upload == attachment);
      this.setState({ uploadsInProgress });
      clonedStep.attachments.push(createdAttachment);
    });
    this.animateProgress();
  }

  handleNotApplicableButton() {
    const { completionStep } = this.state;
    this.csDataSource.performAction('markNotApplicable', completionStep);
  }

  handleUndoNotApplicable() {
    const { completionStep } = this.state;
    this.csDataSource.performAction('unmarkNotApplicable', completionStep);
  }

  handleKeyDown(e, type) {
    if (e.keyCode == 27) {
      this.setState({ rejectionComment: false });
    } else if (e.keyCode == 13 || e.keyCode == 40) {
      e.preventDefault();
      this.handleCommentSent(type, this.state.commentText);
    }
  }

  handleCancelComment() {
    this.setState({
      rejectionComment: false,
    });
  }

  async handleCommentSent(type, commentText) {
    this.setState({ rejectionComment: false });
    
    const { completionStep } = this.state;
    this.csDataSource.performAction('rejectCompletionCriterion', completionStep, commentText);
  }

  handleCommentChange(e) {
    this.setState({ commentText: e.target.value });
  }

  handleStepApprove() {
    const { userStepPermissions, completionStep } = this.props;
    if (userStepPermissions.has('is_approver')) {
      this.handleApproved(completionStep);
    }
    else if (userStepPermissions.has('is_reviewer')) {
      this.handleReviewed(completionStep);
    }
  }

  handleStepReject() {
    const { userStepPermissions, task } = this.props;
    if (userStepPermissions.has('accept/reject')) {
      if((task.has_reviewer && this.state.completionStep.reviewed_at) || !task.has_reviewer){
        this.handleRejectApproval(this.state.completionStep);
      }
      else{
        this.handleRejectReview(this.state.completionStep);
      }
    }
  }

  handleReviewed(completionStep) {
    this.csDataSource.performAction('reviewCompletionCriterion', completionStep);
  }

  handleRejectReview(completionStep) {
    this.setState({ rejectionComment: true });
  }

  handleApproved(completionStep) {
    this.csDataSource.performAction('approveCompletionCriterion', completionStep);
  }

  handleRejectApproval(completionStep) {
    this.setState({ rejectionComment: true });
  }

  animateProgress() {
    let width = 0;
    const self = this;
    this.interval = setInterval(() => {
      if (self.progressElement && self.loadingElement) {
        let parentRect = self.loadingElement.getBoundingClientRect();

        width++;
        if (width >= parentRect.width) {
          width = 0;
        }
        self.setState({ progressWidth: width });
      }
    }, 5);
  }

  setFocus(element) {
    if (element) {
      this.commentInput = element;
      element.focus();
    }
  }

  handleDetermineRejected(task){
    const stepsRejected = task.completion_criteria
    ? task.completion_criteria.filter(cc => {
      if (cc) {
        return (
          cc.rejected_at &&
          !cc.approved_at &&
          !cc.reviewed_at &&
          !cc.completed_at
        );
      }
      else {
        return false;
      }
    }
    )
    : [];
    return stepsRejected.length > 0;
  }

  getNAImageForFileType() {
    const { completionStep } = this.state;
    if (completionStep && completionStep.requested_file_type) {
      return fileTypeToNAIcons[completionStep.requested_file_type];
    }
    else return naOtherIcon;
  }

  renderAttachmentList() {
    const { completionStep, uploadsInProgress } = this.state;
    
    let uploading = false;
    let cardIsDark = true;
    const completedUploads = completionStep.attachments
      .filter(attachment => (attachment.id && attachment.upload))
      .map(attachment => {
        cardIsDark = !cardIsDark;
        if(attachment.id < 0){
          uploading = true;
        }
        else{
          uploading = false;
        }
        return (
          <FileCard
            key={'file-card-' + attachment.id} 
            attachment={attachment} 
            handleFileSelected={!uploading && this.displayFile}
            completionStepId={completionStep ? completionStep.id : null} 
            extensionType={completionStep ? completionStep.requested_file_type : null}
            noBorder={true}
            uploadInProgress={uploading}
            dark={cardIsDark}
          />
        );
      });

    const inProgressUploads = uploadsInProgress.map(upload => {
      cardIsDark = !cardIsDark;
      return (
        <FileCard
          key={'file-card-' + Math.ceil(Math.random() * 20000)} 
          handleFileSelected={this.displayFile}
          uploadInProgress={true}
          attachment={upload}
          completionStepId={completionStep ? completionStep.id : null} 
          extensionType={completionStep ? completionStep.requested_file_type : null}
          noBorder={true}
          dark={cardIsDark}
        />
      );
    });

    return (
      <div className="uploads-list">
        {completedUploads}
        {inProgressUploads}
      </div>
    );
  }

  render() {
    const { 
      editing, 
      task, 
      userStepPermissions,
    } = this.props;
    const { completionStep } = this.state;
    if (!completionStep) {
      return null;
    }
    const { uploadsInProgress, displayedFile } = this.state;

    let buttons = [];
    let reviewApproveButtons = null;
    const totalNumberOfUploads = uploadsInProgress.length + completionStep.attachments.length;
    const firstUploadInProgress = (totalNumberOfUploads == 1 && uploadsInProgress.length == 1);
    const typeInLowerCase = completionStep.requested_file_type && completionStep.requested_file_type.toLowerCase();
    
    if (
      !editing &&
      userStepPermissions.has('accept/reject') && !completionStep.rejected_at) {
      reviewApproveButtons = (
        <div className="misc-approve-reject-buttons">
          <StepApproval key={(task.has_reviewer && (userStepPermissions.has('is_reviewer') || this.props.currentUser.super_admin) &&
            !completionStep.reviewed_at ? '_review' : '_approve') + completionStep.id} userStepPermissions={userStepPermissions}
            handleStepReject={this.handleStepReject}
            handleStepApprove={this.handleStepApprove}
          />
        </div>
      );
    }

    let uploading = <AttachmentUploading/>;

    let displayComponent = null;
    if (completionStep.not_applicable) {
      displayComponent = (
        <img
          className="misc-default-image-display"
          src={this.getNAImageForFileType()}
          alt="not applicable"
          data-qa="not-applicable-image"
        />
      );
    }
    else if (totalNumberOfUploads == 1 && !firstUploadInProgress && typeInLowerCase != 'other') {
      displayComponent = this.fileTypeInfo.filledImage;
    }
    else if (totalNumberOfUploads > 1 || typeInLowerCase == 'other') {
      displayComponent = this.renderAttachmentList();
    }
    else if (!editing) {
      displayComponent = (
        <img
          className="misc-default-image-display"
          src={this.fileTypeInfo.defaultImage}
          alt="file type"
        />
      );
    }
    let swapIconPresent, buttonList;
    if (!editing) {
      if (this.state.naButton) {
        buttons.push(
          <div
            className="button na-button"
            key="na-button"
            onClick={this.handleNotApplicableButton}
            data-qa="not-applicable-button"
          />
        );
      }
      if (
        !completionStep.not_applicable &&
        PhotoPermissionsUtil.canUserEditPhoto(userStepPermissions, completionStep, task) &&
        (totalNumberOfUploads < MiscConstants.MAX_NUMBER_OF_FILES)
      ) {
        buttons.push(
            <div 
              className="button add-button" 
              key="add-button" 
              onClick={this.showUploadModal}
            />
          );
      }
      if (
        completionStep.not_applicable && (userStepPermissions.has('unmarkNA') ||
        ((userStepPermissions.has('step_complete') || userStepPermissions.has('step_update')) &&  
        !completionStep.reviewed_at && !completionStep.approved_at &&
        (completionStep.status != 'completed'))
      )) {
        buttons.push(
          <div
            className="button undo-na-button"
            key="undo-na-button"
            onClick={this.handleUndoNotApplicable}
            data-qa="not-applicable-button"
          />
        );
      }
  
      buttonList = (
        <div
          className={`misc-button-list ${
            totalNumberOfUploads > 0 ? 'attachment-list ' : ''
          }
          ${
            userStepPermissions.has('accept/reject')
          }
          ${
            swapIconPresent ? 'swap-misc ' : ''
          }`}
        >
          {buttons}
        </div>
      );
    }

    let commentDisplay = null;
    let background = null;

    if (!editing && this.state.rejectionComment) {
      buttonList = null;
      const element = document.getElementById(
        'task-completion-step-comments-' + completionStep.id
      );
      const rect = element.getBoundingClientRect();
      commentDisplay = (
        <CommentPopup
          task={task}
          completionStep={completionStep}
          height={element.clientHeight}
          width={element.clientWidth}
          left={rect.left}
          top={rect.top - 20}
          type={'REJECTED'}
          commentSent={commentText =>
            this.handleCommentSent('reject', commentText)
          }
          placeholder={
            'You must leave a comment to reject a Completion Step.'
          }
          cancelComment={this.handleCancelComment}
        />
      );
    }

    let comments;
    if (!editing) {
      comments = <TaskCompletionStepComments id={'task-completion-step-comments-' + completionStep.id} task={task} completionStep={completionStep} />;
    }

    if (this.state.fileSelected) {
      buttonList = null;
    }

    const progressStyle = this.state.progressWidth ? { width: this.state.progressWidth } : {};

    if (this.props.projectTemplate){
      commentDisplay = null;
      comments = null;
      reviewApproveButtons = null;
      buttonList = null;
    }

    return (
      <div className="misc-upload-step" id={'misc-upload-step-' + completionStep.id}>
        {background}
        {displayedFile && 
          <AttachmentPopup
            task={task}
            completionStep={completionStep}
            attachment={displayedFile}
            handlePopupClose={this.handleCloseAttachmentPopup}
            download={false}
            hasMoreButton={this.canOverrideUpload()}
            userStepPermissions={this.props.userStepPermissions}
          />
        }
        <div className={'display-and-buttons'}>
          {completionStep.instructions && 
            <div className="misc-instructions">
              <div className="instruction-label">Instructions</div>
              <div className="instruction-text">{completionStep.instructions}</div>
            </div>
          }
          {firstUploadInProgress && 
            <div className="progress-container">
              <div className="loading-indicator" id={'loading-indicator-' + this.id} ref={element => {this.loadingElement = element;}}>
                <div className="progress-indicator" id={'progress-indicator-' + this.id} ref={element => {this.progressElement = element;}} style={progressStyle} />
              </div>
            </div>
          }
          {!this.state.attachmentUploading ? displayComponent : uploading}
          {!this.state.attachmentUploading && buttonList}
        </div>
        {
          totalNumberOfUploads >= MiscConstants.MAX_NUMBER_OF_FILES &&
          <span className="max-photos-text">Maximum number of files reached. Delete a file if you wish to upload more. </span>
        }
        {commentDisplay}
        {reviewApproveButtons}
        {comments}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
    attachmentUploading: state.main.attachmentUploading,
  };
};

// For handling state change from a dispatch
export default connect(mapStateToProps, null)(MiscUpload);



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/TaskCompletionStepsContainer/TaskCompletionSteps/MiscUpload/index.js